/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '@/apis/client';
import { EventData } from '@/app/types';

export interface Payload {
  tag?: string;
  page?: number | string;
  size?: number | string;
  sort?: number | string;
  start_date?: string;
  end_date?: string;
  [key: string]: any;
}
export interface ContentListResponseData {
  header?: {
    totalResult?: number;
    pages?: number;
    size?: number;
    currentPage?: number;
  };
  left_nav?: null | Record<string, any>;
  results: EventData[] | null;
}

interface ContentListResponse {
  error: boolean;
  status: number;
  code: number;
  statusText: 'OK' | 'ERROR' | 'Not Found' | 'Internal Server Error';
  data: ContentListResponseData & {
    status?: number;
    error?: boolean;
  };
  results: any[];
}

export const getContentListWithPagination = async (
  contentType: string,
  payload?: Payload,
): Promise<ContentListResponseData | ContentListResponse | null> => {
  const page = payload?.page ?? 1;
  const size = payload?.size ?? 12;

  // Build query params (only essentials)
  const queryParams = new URLSearchParams();
  if (payload?.tag) queryParams.append('tag', payload.tag);
  queryParams.append('page', String(page));
  queryParams.append('size', String(size));

  // Build endpoint with query params
  const endpoint = `content-types/${contentType}/list`;

  // Extract remaining fields to body
  const { sort, start_date, end_date, ...rest } = payload || {};

  // ✅ Include all relevant fields in body
  const body = {
    ...(sort ? { sort } : {}),
    ...(start_date ? { start_date } : {}),
    ...(end_date ? { end_date } : {}),
    page,
    size,
    ...rest,
  };

  try {
    const response: ContentListResponse = await post(endpoint, body);

    if ((response.status === 200 || response.code === 200) && response.error === false) {
      if (response.data != null) {
        // Response in data
        return response.data as ContentListResponseData;
      } else if (response.results != null) {
        return response as ContentListResponseData;
      }
    }

    return null;
  } catch (err) {
    console.error(`[API] Error while fetching ${contentType}:`, err);
    return null;
  }
};
